import {
    all,
    put,
    SagaIterator,
    select,
    takeEvery,
    takeEveryCompletedRequest
} from './core/sagaEffects';
import { CustomerContactDetailsRequest, LanguageChangeRequest } from 'acscp/api/requests';
import { ChangeLocaleFromUserDetails, ChangeLocaleManually, FetchRequest } from 'acscp/actions';
import { CustomerContactDetails } from 'acscp/api/models/customerContactDetails';
import { AppState, AuthState, IntlState, LanguageState } from 'acscp/store';
import { getValidLocale } from 'acscp/translations';
import { userIsLoggedIn } from 'acscp/store/helpers/authHelper';

export function* handleLanguageDifferencesSaga(): SagaIterator {
    yield all([
        takeEveryCompletedRequest(CustomerContactDetailsRequest, changeAppOrUserLanguageIfNecessary),
        takeEvery(ChangeLocaleManually, changeLoggedInUserLanguage)
    ]);
}

export function* changeAppOrUserLanguageIfNecessary(
    response: CustomerContactDetails
): SagaIterator {
    const userLocale = getValidLocale(response.language);
    const intlState = (yield select((state: AppState) => state.intl)) as unknown as IntlState;

    // If the user's saved locale differs from the current app locale...
    if (userLocale !== intlState.locale) {
        if (intlState.languageState === LanguageState.SetManually) {
            // And the current app locale was manually chosen by user,
            // then update user's preference on the server.
            const changeRequest = new LanguageChangeRequest(intlState.locale);
            const fetchAction = new FetchRequest(changeRequest);

            yield put(fetchAction);
        } else {
            // Otherwise, update the app locale to match user's preference.
            yield put(new ChangeLocaleFromUserDetails(userLocale));
        }
    }
}

export function* changeLoggedInUserLanguage(action: ChangeLocaleManually): SagaIterator {
    const authState = (yield select((state: AppState) => state.auth)) as unknown as AuthState;

    if (userIsLoggedIn(authState)) {
        const changeRequest = new LanguageChangeRequest(action.locale);
        const fetchAction = new FetchRequest(changeRequest);

        yield put(fetchAction);
    }
}
